import { errorToString } from '@oneethos/shared'
import { useState } from 'react'
import api from '../api-client'
import { toast } from 'react-toastify'
import { Spinner } from '@fluentui/react'

export const BugfixProcessFundingNotifications = () => {
  const [loading, setLoading] = useState(false)
  const [counting, setCounting] = useState(false)
  const [list, setList] = useState([])
  const [hideItemsWithNotes, setHideItemsWithNotes] = useState(false)
  const [hideItemsWithInstallerProbationaryStatus, setHideItemsWithInstallerProbationaryStatus] = useState(false)
  const [hideItemsWithFundingBlock, setHideItemsWithFundingBlock] = useState(false)

  const itemsWithNotes = list.filter(item => item.notesVisibleToInstallers).length
  const itemsWithInstallerProbationaryStatusOnHold = list.filter(item => item.installerProbationaryStatus[0] === 'On Hold').length
  const itemsWithFundingBlock = list.filter(item => item.fundingBlock).length

  const filteredList = list.filter(item => {
    if (hideItemsWithNotes && item.notesVisibleToInstallers) return false
    if (hideItemsWithInstallerProbationaryStatus && item.installerProbationaryStatus[0] === 'On Hold') return false
    if (hideItemsWithFundingBlock && item.fundingBlock) return false
    return true
  })

  return <div className="desensitize-credit-reports">
    <div className="mb-3">
      Used to report on items ready for funding and send them 1 at a time to the multidoc upload (SOL-901).
    </div>
    <div className="buttons mb-3">
      <button
        className="btn btn-secondary"
        disabled={counting}
        onClick={() => {
          setCounting(true)
          api.get('/tenant/ready-for-funding')
            .then(res => setList(res))
            .catch(ex => toast.error(errorToString(ex)))
            .finally(() => setCounting(false))
        }}
      >{counting ? <Spinner /> : 'Count Ready for Funding'}</button>
      <button
        className="btn btn-danger"
        disabled={loading || list.length === 0}
        onClick={() => {
          if (!confirm('Are you sure you want to process the ready for funding list? This will send one item at a time to the multidoc upload every 5 minutes.')) {
            return
          }
          setLoading(true)
          api.post('/tenant/ready-for-funding/process', {})
            .then(res => toast.success(res.message))
            .catch(ex => toast.error(errorToString(ex)))
            .finally(() => setLoading(false))
        }}
      >{loading ? <Spinner /> : 'Process Ready for Funding...'}</button>
    </div>

    {list.length > 0 ? <>
      <div className="form-group">
        <div className="mb-2">
          Found <strong>{list.length}</strong> ready for funding loan applications.
        </div>
        <label className="my-3 d-flex align-items-center cursor-pointer">
          <input
            className="form-check-input me-2"
            type="checkbox"
            checked={hideItemsWithNotes}
            onChange={e => setHideItemsWithNotes(e.target.checked)}
          />
          Hide {itemsWithNotes} projects with notes
        </label>
        <label className="my-3 d-flex align-items-center cursor-pointer">
          <input
            className="form-check-input me-2"
            type="checkbox"
            checked={hideItemsWithInstallerProbationaryStatus}
            onChange={e => setHideItemsWithInstallerProbationaryStatus(e.target.checked)}
          />
          Hide {itemsWithInstallerProbationaryStatusOnHold} projects with installer probationary status "On Hold"
        </label>
        <label className="my-3 d-flex align-items-center cursor-pointer">
          <input
            className="form-check-input me-2"
            type="checkbox"
            checked={hideItemsWithFundingBlock}
            onChange={e => setHideItemsWithFundingBlock(e.target.checked)}
          />
          Hide {itemsWithFundingBlock} projects with funding block
        </label>
      </div>

      <table className="table table-striped">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Installer ID</th>
            <th>App ID</th>
            <th>Status</th>
            <th>Notes</th>
            <th>Installer Probationary Status</th>
            <th>Funding Block</th>
          </tr>
        </thead>
        <tbody>
          {filteredList.map(item => (
            <tr key={item.lookup}>
              <td>{item.customerName || [item.firstName, item.lastName].filter(Boolean).join(' ')}</td>
              <td>{item.installerID}</td>
              <td><a href={`/project/${item.lookup}`} target="_blank">{item.appId}</a></td>
              <td>{item.status}</td>
              <td>{item.notesVisibleToInstallers}</td>
              <td>{item.installerProbationaryStatus[0]}</td>
              <td>{item.fundingBlock === 'true' ? 'Yes' : 'No'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </> : null}
  </div>
}